import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useFormik } from "formik";
import AuthLayout from "../../Layouts/AuthLayout";
import { useMutation } from "react-query";
import { postRequest } from "../../utils/axios";
import { ResetPasswordValidator } from "../../utils/validators/auth";

//Components
import { Form, Button } from "react-bootstrap";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import Spinner from "react-spinner-material";
import Swal from "sweetalert2";

//styles
import styles from "./styles/login.module.scss";
import "sweetalert2/src/sweetalert2.scss";

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const resetCode = searchParams.get("resetCode") || "";

  const { mutate, isLoading } = useMutation(postRequest, {
    onSuccess(response) {
      console.log(response);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Password reset successfully!",
        showConfirmButton: true,
      }).then(() => {
        window.location.href = "/"; // Redirect to login
      });
    },
    onError(error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response?.data?.message || "Something went wrong",
        showCancelButton: true,
        showConfirmButton: false,
      });
    },
  });

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: ResetPasswordValidator(),
    onSubmit: (values) => {
      mutate({
        url: "da/admin/reset-password",
        data: {
          resetCode,
          email,
          password: values.password,
          confirmPassword: values.confirmPassword,
        },
      });
    },
  });

  return (
    <AuthLayout>
      <div className={styles.formBox}>
        <h2 className={`${styles.header} mb-10`}>Reset Password</h2>
        <Form name="resetPasswordForm" onSubmit={formik.handleSubmit}>
          <Form.Group className={` mb-4`}>
            <div className={`${styles.inputWrapper} rounded`}>
              <Form.Control
                id="password"
                style={
                  formik.touched.password &&
                  formik.errors.password && { border: "1px solid red" }
                }
                type={!showPassword ? "password" : "text"}
                placeholder="Enter new password"
                className={`${styles.input} shadow-none`}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
              {!showPassword ? (
                <AiFillEye
                  onClick={() => setShowPassword(true)}
                  color="grey"
                  size={20}
                />
              ) : (
                <AiFillEyeInvisible
                  onClick={() => setShowPassword(false)}
                  color="grey"
                  size={20}
                />
              )}
            </div>
            {formik.touched.password && formik.errors.password ? (
              <p className="text-sm mt-1" style={{ color: "red" }}>
                <b>{formik.errors.password}</b>
              </p>
            ) : null}
          </Form.Group>

          <Form.Group className={` mb-4`}>
            <div className={`${styles.inputWrapper} rounded`}>
              <Form.Control
                id="confirmPassword"
                style={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword && { border: "1px solid red" }
                }
                type={!showConfirmPassword ? "password" : "text"}
                placeholder="Confirm new password"
                className={`${styles.input} shadow-none`}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
              />
              {!showConfirmPassword ? (
                <AiFillEye
                  onClick={() => setShowConfirmPassword(true)}
                  color="grey"
                  size={20}
                />
              ) : (
                <AiFillEyeInvisible
                  onClick={() => setShowConfirmPassword(false)}
                  color="grey"
                  size={20}
                />
              )}
            </div>
            {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
              <p className="text-sm mt-1" style={{ color: "red" }}>
                <b>{formik.errors.confirmPassword}</b>
              </p>
            ) : null}
          </Form.Group>

          <Button type="submit" size="lg" className={`${styles.btn} mt-3`}>
            {isLoading ? (
              <Spinner
                className="mx-auto"
                color="white"
                radius={28}
                stroke={2}
              />
            ) : (
              "Reset Password"
            )}
          </Button>
          <div className="text-center text-sm mt-3">
            <b>
              Remember your password?{" "}
              <Link to="/" style={{ textDecoration: "none" }}>
                Login
              </Link>
            </b>
          </div>
        </Form>
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
